import React from 'react';
import {Avatar, Box, Card, CardActions, CardContent, Chip, Typography} from '@mui/material';
import { Link } from 'react-router-dom';
import InventoryIcon from '@mui/icons-material/Inventory';
import DescriptionIcon from '@mui/icons-material/Description';
import RestaurantIcon from '@mui/icons-material/Restaurant';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import CategoryIcon from '@mui/icons-material/Category';
import StorageIcon from '@mui/icons-material/Storage';
import { Button } from '@mui/material';

interface StatCardConfig {
    title: string;
    icon: string;
    color: string;
    link?: string;
    btnLabel?: string;
    key: string;
}

const iconMap = {
    InventoryIcon: <InventoryIcon fontSize="large" color="primary" />,
    DescriptionIcon: <DescriptionIcon fontSize="large" color="primary" />,
    RestaurantIcon: <RestaurantIcon fontSize="large" color="primary" />,
    AttachMoneyIcon: <AttachMoneyIcon fontSize="large" color="primary" />,
    CategoryIcon: <CategoryIcon fontSize="large" color="primary" />,
    StorageIcon: <StorageIcon fontSize="large" color="primary" />,
};

interface StatCardProps {
    config: StatCardConfig;
    value: number | string;
}

const StatCard: React.FC<StatCardProps> = ({ config, value }) => {
    return (
        <Card
            elevation={2}
            sx={{
                background: config.color,
                transition: 'box-shadow 0.2s',
                '&:hover': { boxShadow: 8 },
                borderRadius: 2,
            }}
        >
            <CardContent sx={{ pb: 1 }}>
                <Box display="flex" alignItems="center" mb={1}>
                    <Avatar sx={{ bgcolor: 'white', mr: 2 }}>{iconMap[config.icon]}</Avatar>
                    <Typography variant="h6" color="text.primary">
                        {config.title}
                    </Typography>
                </Box>
                <Box display="flex" alignItems="alignBaseline">
                    {config.key !== 'chromaStatus' ? (
                        <Typography variant="h3" color="primary">
                            {value}
                        </Typography>
                    ) : (
                        <Chip
                            label={value as string}
                            color={value === 'Connected' ? 'success' : 'error'}
                            sx={{ fontSize: 18, px: 2, py: 1 }}
                            size="medium"
                        />
                    )}
                </Box>
            </CardContent>
            {config.btnLabel && config.link && (
                <CardActions sx={{ pt: 0 }}>
                    <Button component={Link} to={config.link} variant="contained" fullWidth>
                        {config.btnLabel}
                    </Button>
                </CardActions>
            )}
        </Card>
    );
};

export default StatCard;